var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_24424_553)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 32,
    height: 32,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 16.8388C27 17.0084 26.9298 17.1712 26.8047 17.2912C26.6797 17.4111 26.5101 17.4786 26.3333 17.4786H23.6542C23.6617 17.5841 23.6667 17.6905 23.6667 17.7985C23.6651 19.0706 23.1378 20.2903 22.2005 21.1898C21.2631 22.0894 19.9923 22.5954 18.6667 22.5969H17.3908L23.4483 27.8816C23.5143 27.9378 23.568 28.006 23.6064 28.0822C23.6447 28.1585 23.6669 28.2413 23.6716 28.3258C23.6764 28.4104 23.6636 28.495 23.634 28.5747C23.6044 28.6545 23.5586 28.7278 23.4993 28.7905C23.44 28.8532 23.3683 28.9039 23.2883 28.9398C23.2084 28.9756 23.1219 28.9959 23.0337 28.9994C22.9456 29.003 22.8576 28.9897 22.7749 28.9603C22.6921 28.931 22.6162 28.8862 22.5517 28.8285L15.2183 22.4306C15.1188 22.3437 15.0489 22.23 15.018 22.1043C14.987 21.9786 14.9964 21.8469 15.0449 21.7265C15.0934 21.606 15.1788 21.5025 15.2897 21.4294C15.4007 21.3564 15.5321 21.3173 15.6667 21.3173H18.6667C19.6388 21.3163 20.5708 20.9452 21.2582 20.2855C21.9456 19.6258 22.3322 18.7314 22.3333 17.7985C22.3333 17.6905 22.3275 17.5841 22.3175 17.4786H15.6667C15.4899 17.4786 15.3203 17.4111 15.1953 17.2912C15.0702 17.1712 15 17.0084 15 16.8388C15 16.6691 15.0702 16.5063 15.1953 16.3864C15.3203 16.2664 15.4899 16.199 15.6667 16.199H21.9308C21.6238 15.6215 21.1565 15.1367 20.5805 14.798C20.0045 14.4593 19.3422 14.2799 18.6667 14.2796H15.6667C15.4899 14.2796 15.3203 14.2122 15.1953 14.0922C15.0702 13.9722 15 13.8095 15 13.6398C15 13.4701 15.0702 13.3074 15.1953 13.1874C15.3203 13.0674 15.4899 13 15.6667 13H26.3333C26.5101 13 26.6797 13.0674 26.8047 13.1874C26.9298 13.3074 27 13.4701 27 13.6398C27 13.8095 26.9298 13.9722 26.8047 14.0922C26.6797 14.2122 26.5101 14.2796 26.3333 14.2796H22.0617C22.6563 14.8077 23.1087 15.4663 23.38 16.199H26.3333C26.5101 16.199 26.6797 16.2664 26.8047 16.3864C26.9298 16.5063 27 16.6691 27 16.8388Z",
    fill: "#0F5EFF",
    stroke: "#0F5EFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24424_553",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_24424_553"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0 0.458824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24424_553"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24424_553",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.da681ca1055cfb08ffc991f18fdd862a.svg";
export { ForwardRef as ReactComponent };